<template>
  <b-container>
    <b-row class="text-left">
      <b-col>
        <h2>Labels</h2>
        <h5 class="text-secondary">
          <font-awesome-icon icon="sitemap" size="1x"/>
          {{ globalData.currentOrganization.name }}
        </h5>
      </b-col>
    </b-row>
    <b-row class="border shadow-lg user-select-none bg-light text-left mt-2 pt-2 pb-2" align-v="center">
      <b-col md="7" lg="5">
        <b-form-input
            autofocus
            v-model="filter"
            placeholder="Search Labels"
            autocomplete="off"
        />
      </b-col>
      <b-col cols="4">
      </b-col>
      <b-col cols="3" align-h="end" class="text-right">
        <b-button variant="success" lass="text-right" @click="onCreateLabel">Create</b-button>
      </b-col>
    </b-row>
    <br/>

    <b-table
        hover
        small
        class="text-left"
        :items="labels"
        :fields="fields"
        :filter="filter"
        @row-hovered="onRowHovered"
        @row-unhovered="onRowUnHovered"
    >
      <template #cell(name)="data">
        <div class="d-flex align-items-center">
          <input
              class="label-color mr-2"
              type="color"
              :disabled="! canEdit(data.item)"
              v-model="data.item.color"
              @change="onUpdateLabel(data.item)"
          />
          <b-form-input
              class="label-text"
              size="sm"
              :readonly="! canEdit(data.item)"
              v-model="data.item.text"
              @change="onUpdateLabel(data.item)"
          />
          <b-badge
              v-if="isGlobal(data.item)"
              class="ml-2"
              variant="secondary"
              title="Shared by all organizations, read-only"
          >Global</b-badge>
        </div>
      </template>

      <template #cell(actions)="data">
        <font-awesome-icon
            v-if="data.index === hoveredIndex && canEdit(data.item)"
            class="row-button mr-2 text-secondary"
            icon="trash"
            title="Delete"
            size="1x"
            @click.stop="onDeleteLabel(data.item)"
        />
      </template>
    </b-table>
  </b-container>
</template>

<script>
import GlobalDataMixin from "@/components/GlobalDataMixin";

// The global group's id in the API (auth.GLOBAL_GROUP_ID)
const GLOBAL_GROUP_ID = 0;

export default {

  name: 'LabelView',
  mixins: [GlobalDataMixin],
  data() {
    return {
      filter: "",
      fields: [
        {key: 'name', label: 'Label'},
        {key: 'actions', label: '', thStyle: {width: "60px"},},
      ],
      labels: [],
      hoveredIndex: null,
    }
  },
  props: {
    globalData: Object
  },
  watch: {
    globalData: {
      handler() {
        this.refresh();
      },
      deep: true
    },
  }, created() {
    this.refresh();
  },
  methods: {
    isGlobal(label) {
      return label.owningGroup === GLOBAL_GROUP_ID;
    },
    canEdit(label) {
      // Global labels are shared by all organizations and read-only here
      return !this.isGlobal(label) && this.hasAdminAccessToOrganization(label.owningGroupUuid);
    },
    refresh: function () {
      this.$http.get(`/api/labels`)
          .then(response => {
            this.labels = response.data
          })
          .catch(e => {
            console.warn(e)
          })
    },
    onCreateLabel: function () {
      this.$http.post(`/api/labels`)
          .then(() => {
            this.refresh();
          })
          .catch(e => {
            console.warn(e)
          })
    },
    onRowHovered(item, index) {
      this.hoveredIndex = index;
    },
    onRowUnHovered() {
      this.hoveredIndex = null;
    },
    onDeleteLabel(label) {
      this.$bvModal.msgBoxConfirm(
          `Are you sure you want to delete ${label.text}? It will be removed from all workouts and runners that use it.`, {
            title: `Delete ${label.text}`,
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes, Delete',
            cancelTitle: 'No, Keep It',
            centered: true
          })
          .then(value => {
            if (!value) {
              return;
            }
            this.$http.delete(`/api/labels/${label.uuid}`)
                .then(response => {
                  this.$bvToast.toast(`Removed from ${response.data.workouts} workouts and ${response.data.users} runners`, {
                    title: `${label.text} deleted`,
                    toaster: 'b-toaster-bottom-center',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000,
                    noCloseButton: true,
                    appendToast: true,
                  });
                  this.refresh();
                })
                .catch(e => {
                  console.warn(e)
                })
          })
          .catch(e => {
            console.warn(e)
          })
    },
    onUpdateLabel: function (item) {
      console.log(item.text);
      console.log(item.color);
      this.$http.post(`/api/labels/${item.uuid}`, item)
          .then(() => {
            this.refresh();
          })
          .catch(e => {
            console.warn(e)
          })
    },
  }
}
</script>

<style scoped>
.row-button {
  cursor: pointer;
}

/* Compact rows like the Workouts table: inline editors look like plain text until hovered or focused */
.label-color {
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}

.label-color:disabled {
  cursor: default;
}

.label-color::-webkit-color-swatch-wrapper {
  padding: 0;
}

.label-color::-webkit-color-swatch {
  border: none;
  border-radius: 0.2rem;
}

.label-color::-moz-color-swatch {
  border: none;
  border-radius: 0.2rem;
}

.label-text {
  max-width: 20rem;
  height: auto;
  padding: 0 0.25rem;
  border-color: transparent;
  background-color: transparent;
}

.label-text:not([readonly]):hover,
.label-text:not([readonly]):focus {
  border-color: #ced4da;
  background-color: #fff;
}

.label-text[readonly] {
  box-shadow: none;
}
</style>
